module.exports = __webpack_public_path__ + "img/logo.ab0027b0.png";